import { MetaTagEndpoints, MetaTagService, MetaTags } from 'src/services/metaTag'
import useRequest from '../useRequest'
import { UseGetLinkPreviewProps } from './useGetLinkPreview.types'

const neededMetaTags = [MetaTags.IMAGE_TAG, MetaTags.TITLE_TAG, MetaTags.URL_TAG]

export const useGetLinkPreview = ({ linkUrl }: UseGetLinkPreviewProps) =>
  useRequest(
    `${MetaTagEndpoints.linkPreview()}/${linkUrl}`,
    () => MetaTagService.getLinkPreviewMetatag(linkUrl, neededMetaTags),
    {
      enabled: Boolean(linkUrl)
    }
  )

export default useGetLinkPreview
